// Types partagés pour les workflows de rédaction prédéfinis (WorkflowTemplate).
// Miroir des sérialisations de courriers/views_workflow_templates.py.

export type StepKind = 'FIXED_ENTITY' | 'HIERARCHIE_INITIATEUR' | 'ROLE_NATIONAL'
export type TargetType = 'DIRECTION' | 'DEPARTEMENT' | 'SERVICE' | 'AMBASSADE' | 'USER'
export type InstructionType = 'ACTION' | 'ACTION_CONJOINTE' | 'CONSULTATION' | 'INFO'
export type RoleNationalCode = 'ASSISTANT_SGA' | 'SGA' | 'SG' | 'DC' | 'ATM' | 'MINISTRE'

export interface StepTarget {
  type: TargetType
  id: number
  label: string
}

export interface WorkflowStep {
  id?: number
  ordre: number
  kind: StepKind
  target_type?: TargetType | null
  target?: StepTarget | null
  // Écriture uniquement (non renvoyé par la lecture, `target` le remplace) :
  target_id?: number | null
  role_national_code?: RoleNationalCode | string | null
  instruction_type: InstructionType
  is_principal: boolean
  requires_paraphe: boolean
  requires_signature: boolean
}

export interface WorkflowTemplateRef { id: number; nom: string }
// `via_regle` : le type n'utilise ce workflow que par une règle de profil.
export interface DocumentTypeRef { id: number; code: string; nom: string; via_regle?: boolean }

// Règle de profil d'un type de document, telle que le formulaire la manipule :
// identifiants en texte pour les <select>, direction vide = toutes les directions.
export interface RegleBrouillon {
  role_ids: number[]
  direction_id: string
  workflow_template_id: string
}

export interface WorkflowTemplate {
  id: number
  nom: string
  description: string
  is_active: boolean
  document_types: DocumentTypeRef[]
  steps: WorkflowStep[]
  steps_count?: number
  created_at: string
  updated_at: string
}

export const ROLE_NATIONAL_OPTIONS: { code: RoleNationalCode; label: string }[] = [
  { code: 'ASSISTANT_SGA', label: 'Assistant SGA' },
  { code: 'SGA', label: 'Secrétaire Général Adjoint' },
  { code: 'SG', label: 'Secrétaire Général' },
  { code: 'DC', label: 'Directrice de Cabinet' },
  { code: 'ATM', label: 'Assistant(e) Technique du Ministre' },
  { code: 'MINISTRE', label: 'Ministre' },
]

export const ROLE_NATIONAL_LABELS: Record<string, string> = Object.fromEntries(
  ROLE_NATIONAL_OPTIONS.map(o => [o.code, o.label])
)

export const INSTRUCTION_TYPE_OPTIONS: { value: InstructionType; label: string }[] = [
  { value: 'ACTION', label: 'Pour action' },
  { value: 'ACTION_CONJOINTE', label: 'Pour action conjointe' },
  { value: 'CONSULTATION', label: 'Pour consultation' },
  { value: 'INFO', label: 'Pour information' },
]

export const TARGET_TYPE_OPTIONS: { value: TargetType; label: string }[] = [
  { value: 'DIRECTION', label: 'Direction' },
  { value: 'DEPARTEMENT', label: 'Département' },
  { value: 'SERVICE', label: 'Service' },
  { value: 'AMBASSADE', label: 'Ambassade' },
  { value: 'USER', label: 'Utilisateur précis' },
]

export const emptyStep = (ordre: number): WorkflowStep => ({
  ordre,
  kind: 'FIXED_ENTITY',
  target_type: 'DIRECTION',
  target_id: null,
  role_national_code: null,
  instruction_type: 'ACTION',
  is_principal: false,
  requires_paraphe: true,
  requires_signature: false,
})
